import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCamera3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3V21H22V3H2ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM17.5 8.75C16.8096 8.75 16.25 8.19036 16.25 7.5C16.25 6.80964 16.8096 6.25 17.5 6.25C18.1904 6.25 18.75 6.80964 18.75 7.5C18.75 8.19036 18.1904 8.75 17.5 8.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera3;
